angular.module('forms').directive('apFormQuestion',
    [
        function () {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: '/forms/views/directives/apFormQuestion.html',
                scope: {
                    // Use '@' for one way binding.  String value is returned.
                    // Use '=' for two way binding.  An object is returned.
                    // Use '&' for a method.
                    question: '=question',
                    form: '=form'
                },
                controller: function($scope) {
                    var formAnswerChangedListener = null;
                    var formAnswerExplanationTextChangedListener = null;


                    function formAnswerChanged(eventData) {
                        if ($scope.question.SurveyQuestionId === eventData.QuestionIdToTrigger) {
                            //console.log((eventData.EnableQuestion ? 'Enable ' : 'Disable ') + 'question ' + $scope.question.QuestionNumber);
                            $scope.question.QuestionEnabled = eventData.EnableQuestion;  // $scope.question.QuestionEnabled is bound to ng-disabled on the answer templete.
                            $scope.question.QuestionRequireAnswer = eventData.EnableQuestion;

                            if ($scope.question.QuestionEnabled === false) {
                                $scope.question.SelectedAnswerId = null;
                                $scope.question.SelectedAnswerText = '';

                                _.forEach($scope.question.Answers, function(answer) {
                                    answer.SelectedAnswer = false;
                                    answer.SurveyResponseAnswerText = '';
                                });
                            }
                        }
                    }


                    function formAnswerExplanationTextChanged(eventData) {
                        if (eventData.SurveyQuestionId !== $scope.question.SurveyQuestionId) {
                            return;
                        }

                        if ($scope.question.QuestionEnabled !== true) {
                            return;
                        }

                        $scope.question.RequiredFieldsPopulated = isRequiredExplanationTextPopulated();
                    }


                    $scope.$on('$destroy', function() {
                        if (formAnswerChangedListener !== null) {
                            formAnswerChangedListener();
                        }
                        if (formAnswerExplanationTextChangedListener !== null) {
                            formAnswerExplanationTextChangedListener();
                        }
                    });


                    function loadView() {
                        // TODO : Remove boolean flag.  Check if collection is empty or not.
                        if ($scope.question.HasAnswersThatTriggerThisQuestion === true) {
                            //console.log('Has Listener : ' + $scope.question.QuestionNumber);
                            formAnswerChangedListener = $scope.$on('FormAnswerChanged', function(event, data) {
                                formAnswerChanged(data);
                            });
                        }

                        formAnswerExplanationTextChangedListener = $scope.$on('ExplanationTextChanged', function(event, data) {
                            formAnswerExplanationTextChanged(data);
                        });
                    }
                    loadView();


                    function isRequiredExplanationTextPopulated() {
                        var isTextPopulated = false;
                        var unselectedAnswers;

                        if ($scope.question.SurveyControlTypeName.toUpperCase() === 'RADIOBUTTON') {
                            if ($scope.question.SelectedAnswerId === null) return false;

                            unselectedAnswers = _.filter($scope.question.Answers, function(answer) {
                                return answer.SurveyAnswerId !== $scope.question.SelectedAnswerId;
                            });
                            if (unselectedAnswers) {
                                _.forEach(unselectedAnswers, function (answer) {
                                    answer.SurveyExplanation = '';
                                });
                            }

                            var selectedAnswer = _.find($scope.question.Answers, function(answer) {
                                return (answer.SurveyAnswerId === $scope.question.SelectedAnswerId && answer.SurveyRequiresExplanation === true && !!answer.SurveyExplanation && answer.SurveyExplanation.length > 0);
                            });
                            if (selectedAnswer) {
                                isTextPopulated = true;
                            }
                        }
                        else if ($scope.question.SurveyControlTypeName.toUpperCase() === 'CHECKBOX') {
                            unselectedAnswers = _.filter($scope.question.Answers, function(answer) {
                                return answer.SelectedAnswer === false;
                            });
                            if (unselectedAnswers) {
                                _.forEach(unselectedAnswers, function (answer) {
                                    answer.SurveyExplanation = '';
                                });
                            }

                            var selectedAnswers = _.filter($scope.question.Answers, function(answer) {
                                return (answer.SelectedAnswer === true && answer.SurveyRequiresExplanation === true && (!answer.SurveyExplanation || answer.SurveyExplanation.length <= 0));
                            });
                            if (selectedAnswers && selectedAnswers.length > 0) {
                                isTextPopulated = false;
                            } else {
                                isTextPopulated = true;
                            }
                        }

                        return isTextPopulated;
                    }

                }
            };
        }
    ]
);